export const Translations_MK = {
	footer: {
		join: "Приклучи се на оваа дискусија. Не е потребно најавување.",
		climate: "Позитивна дискусија за климата.",
		tree: "Ова дрво беше засадено.",
		start: "Започнете видео дискусии бесплатно.",
	},
};
